module.exports = __webpack_public_path__ + "static/media/TEDI-Prem logo_final.15f7f1dd.png";